export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ15.e926ccd6.mp3";